var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5219 1.8894H6.14877C4.77858 1.8894 3.46449 2.43371 2.49562 3.40259C1.52673 4.37148 0.982422 5.68555 0.982422 7.05576V33.4289C0.982422 34.7992 1.52673 36.1133 2.49562 37.0821C3.46449 38.0509 4.77858 38.5953 6.14877 38.5953H18.1516V25.1976H13.6138V19.9716H18.1516V16.1221C18.1516 13.9404 18.7549 12.2451 19.9617 11.0406C21.1684 9.83394 22.8041 9.22829 24.871 9.22829C26.9403 9.22829 28.2801 9.30859 28.8926 9.46V14.1125H26.1351C25.1394 14.1125 24.4604 14.3235 24.0956 14.7456C23.7331 15.1655 23.5519 15.7986 23.5519 16.6406V19.9716H28.7206L28.0323 25.1976H23.5519V38.5953H32.5219C33.8922 38.5953 35.2063 38.0509 36.1751 37.0821C37.1441 36.1133 37.6883 34.7992 37.6883 33.4289V7.05576C37.6883 5.68555 37.1441 4.37148 36.1751 3.40259C35.2063 2.43371 33.8922 1.8894 32.5219 1.8894Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.911807a862dae50387068d061867e1ef.svg";
export { ForwardRef as ReactComponent };